export type SocialPlatform = 'facebook' | 'instagram' | 'tiktok' | 'twitter';

export const SOCIAL_PLATFORMS: SocialPlatform[] = ['facebook', 'instagram', 'tiktok', 'twitter'];

export const PLATFORM_LOGOS: Record<SocialPlatform, string> = {
  facebook: '/img/redesSociales/facebook.png',
  instagram: '/img/redesSociales/instagram.png',
  tiktok: '/img/redesSociales/tiktok.png',
  twitter: '/img/redesSociales/twitter.png',
};

export const PLATFORM_URLS: Record<SocialPlatform, string> = {
  facebook: 'https://www.facebook.com/',
  instagram: 'https://www.instagram.com/',
  tiktok: 'https://www.tiktok.com/',
  twitter: 'https://x.com/',
};


export const PLATFORM_URLS_LINKSERVS: Record<SocialPlatform, string> = {
  facebook: 'https://www.facebook.com/profile.php?id=61586818906008',
  instagram: 'https://www.instagram.com/linkservs/',
  tiktok: 'https://www.tiktok.com/@linkservs?lang=es',
  twitter: 'https://x.com/Linkservs',
};
